import _get from 'lodash/get';

import {
  GET_INDENTS_LIST_T,
  GET_EMAILS_LIST_TICKET,
  SAVE_FILTERS,
  RESET_TABLE_TICKET,
  UPDATE_TAB,
  UNTICK_FLAGS,
  GET_BASIC_DETAILS_TICKET,
  ADD_NEW_TTCKET,
  GET_TICKET_DETAILPAGE_DETAILS,
  UPDATE_TICKET_DETAILS,
  ADD_NEW_COMMENT,
  GET_CONVERSATION,
  GET_TICKETING_ENTITIES,
  POST_TICKETING_FIELD,
  VIEW_UPLOADED_DOCUMENT2,
  UPLOAD_DOCUMENTS,
  GET_COMMENTS,
  GET_DETAILS_CONFIG,
  GET_STOPPAGE_REASONS,
  GET_TICKETS_BY_CONSIGNMENT,
  GET_AI_REMARK,
} from './actions';

import { REQUEST, SUCCESS, FAILURE, RESET } from '../../../utils/actionGenerator';

const initialPlacementData = {
  PENDING: {
    list: [],
    count: null,
  },
  FULFILLED: {
    list: [],
    count: null,
  },
  EXPIRED: {
    list: [],
    count: null,
  },
};
const today = new Date();
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

const kycStatus = {
  name: 'Verified',
  key: 'VERIFIED',
  value: 'Verified',
};

// const userType = window.location
const userType = window?.location?.pathname === '/portal/ptl-ticketing' ? 'PTL_CONSIGNER' : null;

const defaultState = {
  indents: [],
  fetchingIndents: false,
  indentCount: null,
  indentAssigned: false,
  filterObject: {
    // consignerTypes: [],

    // createdBy: [],
    // assignedTo: [],
    opsPoc: [],
    bizPoc: [],
    sources: [],
    userType: userType,
    createdBy: '',
  },
  selectedTab: 0,
  headerDetails: {},
  currentStateContext: '',
  // placementData: { ...initialPlacementData },
  basicDetails: {},
  createdByEmailsList: [],
  assignedToEmailsList: [],
  addNewTicketDone: '',
  ticketDetailPageDetails: {},
  updatedTicketDetails: false,
  addNewCommentUpdated: false,
  conversationList: [],
  ticketRemarksOptions: [],
  isFetchingRemarksOptions: false,
  ticketingEntity: {},
  postticketingEntity: false,
  uploadedDocumentViewUrl: '',
  imgResourceKey: '',
  commentsList: [],
  detailsConfig: {},
  detailsConfigloading: false,
  uploadedFileName: '',
  redirectToTicket: '',
  ticketsByConsignment: {},
  aiRemark: null,
  aiRemarkLoading: false,
  aiRemarkError: null,
  isDamageTicket: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_INDENTS_LIST_T[REQUEST]:
      console.log('fetchingIndents coming here - ');
      return { ...state, fetchingIndents: true };
    case GET_INDENTS_LIST_T[SUCCESS]: {
      return {
        ...state,
        fetchingIndents: false,
        indents: (action.response.tickets !== null && state.indents.concat(action.response.tickets)) || state.indents,
        indentCount: (action.response.count && action.response.count) || null,
      };
    }
    case GET_INDENTS_LIST_T[FAILURE]: {
      return {
        ...state,
        indents: [],
        fetchingIndents: false,
        // indents: [
        //   {"ticketId": 123,
        //   "status": "ACTIVE",
        //   "createdAt": "string",
        //   "demandId": 123,
        //   "consignmentCode": 1234,
        //   "consignerCode": 1234,
        //   "consignerName": 1234,
        //   'source':'djskek',
        //   "subject": 'newOne',
        //   "userCode": 1234,
        //   "userType": 'hello1',
        //   "followUpTime": 11212332332,
        //   "opsPoc": "ankit",
        //   "bizPoc": "string",
        //   "desc": "232"
        //   },
        //   {"ticketId": 9876,
        //   "status": "ACTIVE",
        //   "createdAt": "string",
        //   "demandId": 9876,
        //   "consignmentCode": 9876,
        //   "consignerCode": 9876,
        //   "consignerName": 9876,
        //   'source':'djskek',

        //   "subject": 'newOne',
        //   "userCode": 9876,
        //   "userType": 'hello1',
        //   "followUpTime": 11212332332,
        //   "opsPoc": "ankit",
        //   "bizPoc": "string",
        //   "desc": "232"
        //   }
        // ],
        indentCount: 1000 || null,
      };
    }
    case GET_EMAILS_LIST_TICKET[REQUEST]:
      return { ...state };
    case GET_EMAILS_LIST_TICKET[SUCCESS]: {
      if ((action?.params?.type ?? '') === 'BIZ') {
        return { ...state, createdByEmailsList: action.response.userDTOS };
      } else {
        return { ...state, assignedToEmailsList: action.response.userDTOS };
      }
    }
    // case ASSIGN_INDENT[REQUEST]:
    //   return { ...state, indentAssigned: false };
    // case ASSIGN_INDENT[SUCCESS]:
    //   return { ...state, indentAssigned: true, indents: [] };
    case SAVE_FILTERS:
      return { ...state, filterObject: action.filter };
    case UNTICK_FLAGS:
      return { ...state, indentAssigned: false };
    case RESET_TABLE_TICKET:
      return { ...state, indents: [], placementData: { ...initialPlacementData } };
    case UPDATE_TAB:
      return { ...state, selectedTab: action.value, indentCount: null };
    case GET_BASIC_DETAILS_TICKET[REQUEST]:
      return { 
        ...state, 
        basicDetails: {}
      };
    case GET_BASIC_DETAILS_TICKET[SUCCESS]:
      return { ...state, basicDetails: action.response };
    case GET_BASIC_DETAILS_TICKET[FAILURE]:
      return {
        ...state,
        basicDetails: {
          ticketId: 1234,
          consignerName: 'Ankit',
          tripId: '123',
          subject: 'one',
        },
      };

    case ADD_NEW_TTCKET[REQUEST]:
      return { ...state, addNewTicketDone: '' };
    case ADD_NEW_TTCKET[SUCCESS]:
      return { ...state, addNewTicketDone: true, redirectToTicket: action.response.data.ticketId };
    case ADD_NEW_TTCKET[FAILURE]:
      return { ...state, addNewTicketDone: false, redirectToTicket: '' };

    case GET_TICKET_DETAILPAGE_DETAILS[REQUEST]:
      return { ...state, ticketDetailPageDetails: {} };
    case GET_TICKET_DETAILPAGE_DETAILS[SUCCESS]:
      return { ...state, ticketDetailPageDetails: action.response.data };
    case GET_TICKET_DETAILPAGE_DETAILS[FAILURE]:
      return {
        ...state,
        ticketDetailPageDetails: {},
        //   {
        //   "opsPoc": "123",
        //   "bizPoc": "345",
        //   "followUp": "date 1",
        //   "description": "sddcds",
        //   "status": "ACTIVE"
        // }
      };

    case UPDATE_TICKET_DETAILS[REQUEST]:
      return { ...state, updatedTicketDetails: false };
    case UPDATE_TICKET_DETAILS[SUCCESS]:
      return {
        ...state,
        updatedTicketDetails: true,
      };
    case UPDATE_TICKET_DETAILS[FAILURE]:
      return { ...state, updatedTicketDetails: true };

    case ADD_NEW_COMMENT[REQUEST]:
      return { ...state, addNewCommentUpdated: false };
    case ADD_NEW_COMMENT[SUCCESS]:
      return {
        ...state,
        addNewCommentUpdated: true,
      };
    case ADD_NEW_COMMENT[FAILURE]:
      return { ...state, addNewCommentUpdated: true };

    case GET_CONVERSATION[REQUEST]:
      return { 
        ...state, 
        conversationList: [],
        aiRemark: null,
        aiRemarkLoading: false,
        aiRemarkError: null
      };
    case GET_CONVERSATION[SUCCESS]:
      return { ...state, conversationList: action.response.data };

    case GET_COMMENTS[REQUEST]:
      return { ...state, commentsList: [] };
    case GET_COMMENTS[SUCCESS]:
      return {
        ...state,
        commentsList: action.response.data,
        isDamageTicket: action.response.data?.damageTicket || false,
      };
    // case GET_CONVERSATION[FAILURE]:
    // return { ...state, conversationList: [
    //   {
    //     "author": 'Ankit singh',
    //     "time": 1657115340,
    //     "content": 'This is a comment',
    //     "format": "string"
    //   },
    //   {
    //     "author": "Vikas Mishra",
    //     "time": 1657115340,
    //     "content": 'This is a comment',
    //     "format": "string"
    //   }
    // ] };

    case GET_DETAILS_CONFIG[REQUEST]:
      return { ...state, detailsConfig: [], detailsConfigloading: true };
    case GET_DETAILS_CONFIG[SUCCESS]:
      return { ...state, detailsConfig: action.response.data, detailsConfigloading: false };
    // return {
    //   ...state,
    //   detailsConfig: {
    //     remarks: [],
    //     status: ['ACTIVE', 'HOLD', 'RESOLVED'],
    //     secondaryPOCs: {
    //       'vishal.soni@wheelseye.com': 'OPS',
    //       'vikash.k@wheelseye.com': 'CRITICAL',
    //       'damage@wheelseye.com': 'DAMAGE',
    //       'gurbhej.singh@wheelseye.com': 'CST',
    //       'arjun.sharma@wheelseye.com': 'KAM',
    //       'finance@wheelseye.com': 'FINANCE',
    //       'resolution_mp@wheelseye.com': 'RESOLUTION',
    //       'aftertrip@wheelseye.com': 'OTHER',
    //       'fo_onboarding@wheelseye.com': 'FO_ONB',
    //       'fo_kyc@wheelseye.com': 'FO_KYC',
    //     },
    //     ticketIssues: {
    //       category1: ['subcategory1', 'subcategory2', 'subcategory3'],
    //       category2: ['subcategory21', 'subcategory22', 'subcategory33'],
    //       category3: ['subcategory31', 'subcategory2', 'subcategory3'],
    //       category4: ['subcategory41', 'subcategory2', 'subcategory3'],
    //       others: [],
    //     },
    //   },
    //   detailsConfigloading: false,
    // };

    case GET_DETAILS_CONFIG[FAILURE]:
      return { ...state, detailsConfig: {}, detailsConfigloading: false };

    case GET_STOPPAGE_REASONS[REQUEST]:
      return { ...state, stoppageReasons: [] };
    case GET_STOPPAGE_REASONS[SUCCESS]:
      return { ...state, stoppageReasons: action.response.data.reasons };
    case GET_STOPPAGE_REASONS[FAILURE]:
      return { ...state, stoppageReasons: [] };
    case GET_TICKETING_ENTITIES[REQUEST]:
      return {
        ...state,
        ticketingEntity: {},
      };
    case GET_TICKETING_ENTITIES[SUCCESS]:
      return {
        ...state,
        ticketingEntity: action.response,
      };
    case GET_TICKETING_ENTITIES[FAILURE]:
      return {
        ...state,
        ticketingEntity: {},
      };

    case POST_TICKETING_FIELD[REQUEST]:
      return {
        ...state,
        postticketingEntity: null,
      };
    case POST_TICKETING_FIELD[SUCCESS]:
      return {
        ...state,
        ticketingEntity: action.response,
        postticketingEntity: true,
      };
    case POST_TICKETING_FIELD[FAILURE]:
      return {
        ...state,
        postticketingEntity: true,
      };
    case VIEW_UPLOADED_DOCUMENT2[REQUEST]:
      return {
        ...state,
        uploadedDocumentViewUrl: {},
      };
    case VIEW_UPLOADED_DOCUMENT2[SUCCESS]:
      console.log('action.response[0]', action.response[0]);

      return {
        ...state,
        uploadedDocumentViewUrl: action.response[0],
      };

    case UPLOAD_DOCUMENTS[REQUEST]:
      return { ...state, documentUploaded: false };

    case UPLOAD_DOCUMENTS[SUCCESS]:
      return {
        ...state,
        imgResourceKey: action.response[0].data.data.docCode,
        uploadedFileName: action.response[0].data.data.fileName,
        documentUploaded: true,
      };
    case UPLOAD_DOCUMENTS[RESET]:
      return {
        ...state,
        imgResourceKey: '',
        uploadedFileName: '',
        documentUploaded: false,
      };

    case GET_TICKETS_BY_CONSIGNMENT[REQUEST]:
      return {
        ...state,
        ticketsByConsignment: {},
      };

    case GET_TICKETS_BY_CONSIGNMENT[SUCCESS]:
      return {
        ...state,
        ticketsByConsignment: action.response.data || {},
      };
    case GET_TICKETS_BY_CONSIGNMENT[FAILURE]:
      return {
        ...state,
        ticketsByConsignment: {},
      };

    case GET_AI_REMARK[REQUEST]:
      return { ...state, aiRemarkLoading: true, aiRemarkError: null };
    case GET_AI_REMARK[SUCCESS]:
      return { ...state, aiRemark: action.response, aiRemarkLoading: false };
    case GET_AI_REMARK[FAILURE]:
      return { ...state, aiRemarkError: action.error, aiRemarkLoading: false };

    default:
      return state;
  }
}

export const getUploadedDocumentViewUrl = (state) => state.ticketing.uploadedDocumentViewUrl;
export const getFileName = (state) => state.ticketing.uploadedFileName;

export const getPlacementReducer = (state) => state.ticketing;

export const getExpiryReasons = (state) => _get(state, 'placement.placementList.expiryReasons', []);

export const getDemandExpired = (state) => _get(state, 'placement.placementList.demandExpired', false);
export const getImgResourceKey = (state) => state.ticketing.imgResourceKey;
